import { render, staticRenderFns } from "./ExternalLink.vue?vue&type=template&id=de1c1b06&scoped=true&"
import script from "./ExternalLink.vue?vue&type=script&lang=js&"
export * from "./ExternalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1c1b06",
  null
  
)

export default component.exports